/*
 * jQuery Dosage, v 1.0
 * Copyright 2014 Naturalwellbeing
 * Contributing Author: Albert Liu
 * It needs jquery ui slider plugin
 * Its styles are in product_ui.css
 */


jQuery.fn.dosage = function(settings) {
    settings = jQuery.extend({
        range: "max",
        min: 1,
        max: 100,
        pet: 'dog',
        value: 10,
        times_per_day: 2,
        bottle_size: '2 oz',
        drops_per_day:1,
        drops_per_bottle:1180,
        ml_per_bottle:59,
        drops_per_dropper:20,
        get_drops: function(w){
          var adjuster =  settings.times_per_day==2 ? 2 : 1         //some twice a day
          var dropsperday = settings.drops_per_day==2 ? 2 : 1
          if(w>50)
            var drops=(50/adjuster)*dropsperday +Math.ceil((w-50)/2/adjuster*dropsperday);
          else
            drops=Math.ceil(w/adjuster*dropsperday);
          return drops;},
        get_doppers: function(d){
          return parseInt(d/settings.drops_per_dropper);
        },
        get_mls: function(w){
          if(settings.pet=='cat'){ // cat
            if(settings.times_per_day==1){
            if(w<=10)
              return 0.25
            else
              return 0.5
            }
            if(settings.drops_per_day==1){
            if(w<=10)
              return 0.25
            else
              return 0.5
            }
            else
            {
            if(w<=10)
              return 0.25
            else
              return 0.5
            }
          }
          else{
            if(settings.times_per_day==1){
            if(w<=10)
              return 0.25
            else if(w<=20)
              return 0.5
            else if(w<=40)
              return 1
            else if(w<=60)
              return 1.25
            else if(w<=80)
              return 1.5
            else if(w<=100)
              return 1.75
            else
              return 2.0
            }
            if(settings.drops_per_day==1){
            if(w<=10)
              return 0.25
            else if(w<=20)
              return 0.5
            else if(w<=40)
              return 1.0
            else if(w<=60)
              return 1.5
            else if(w<=80)
              return 2.0
            else if(w<=100)
              return 2.5
            else
              return 3.0
            }
            else
            {
            if(w<=10)
              return 0.25
            else if(w<=20)
              return 0.5
            else if(w<=40)
              return 0.75
            else if(w<=60)
              return 1
            else if(w<=80)
              return 1.5
            else if(w<=100)
              return 1.75
            else
              return 2
            }
          }
        },
        get_dropps_left:  function(){},
        get_options: function(){
          var productSingleObject = productSingleObject || JSON.parse(document.getElementById("ProductJson-product-template").innerHTML);
          if(!!productSingleObject.variants)
            this.options = productSingleObject.variants.map(item => item.title.replace('.',''));
          return this.optoins || ['2 oz']
        },
        scales: ['100','75','50','25','0lbs'],
        update_droppers: function(w){          
            if(settings.max == 30 && w>30)
                w=30
          
            var drops=settings.get_drops(w);
            var bottles= settings.get_doppers(drops);

           
            
              mls=settings.get_mls(w)
              if(settings.times_per_day<2)
                mls=mls*2
              if(settings.drops_per_day>1)
                mls=mls*2
              $( "#drops_amount span" ).html( mls + ' ml');
              days_2 = Math.round(settings.ml_per_bottle/mls/settings.times_per_day);
              days_4 = Math.round(2*settings.ml_per_bottle/mls/settings.times_per_day);
              months_2 = Math.round(settings.ml_per_bottle/mls/settings.times_per_day/30);
              weeks_2 = Math.round(settings.ml_per_bottle/mls/settings.times_per_day/7);
              months_4 = Math.round(2*settings.ml_per_bottle/mls/settings.times_per_day/30);
              weeks_4 = Math.round(2*settings.ml_per_bottle/mls/settings.times_per_day/7);
              
           

            var total_width = $('#dosage_calculator').width() || 480;
              $( "#dropper_pet_content" ).css('width', parseFloat(w/settings.max)*100 +'%');
          

          if(!settings.options)
            settings.options = get_options();
          var weightUpdateEvent_2, weightUpdateEvent_4;
          settings.options.forEach(option => {
            //console.log('Updating option: '+ option);
            var temp_id= option.replace(' ','').replace('DefaultTitle','');
            var obj=$( "#droppers_amount_"+ temp_id + " .days_last");
            option= option.toLowerCase().replace('default title','2 oz');            
            if(option=='2 oz')
            {
               if(weeks_2>5)
                $(obj).html(months_2 + ' months');
              else 
              {
                if(weeks_2>1)
                  $(obj).html(weeks_2 + ' weeks');
                else 
                  $(obj).html( weeks_2 + ' week');
              }
            //create the event
            weightUpdateEvent_2 = new CustomEvent('weight_update_' + temp_id, {
              detail: { days_last: days_2 } 
              });
                  // Dispatch the event 
            document.dispatchEvent(weightUpdateEvent_2);  
            //console.log('displathced event: weight_update_' + temp_id);  
            }
            else
            {
              if(weeks_4>5)
                $(obj).html( months_4 + ' months');
              else 
              {
                if(weeks_4>1)
                  $(obj).html(weeks_4 + ' weeks');
                else 
                  $(obj).html( weeks_4 + ' week');
              }
              //create the event
            weightUpdateEvent_4 = new CustomEvent('weight_update_' + temp_id, {
              detail: { days_last: days_4 }
              });
              document.dispatchEvent(weightUpdateEvent_4);
              //console.log('displathced event: weight_update_' + temp_id); 
            }
          });
          
            var w_display = w;
            if(101==settings.max && 101==w)
              w_display='100+'
            if(21==settings.max && 21==w)
              w_display='20+'

            $('.weight_in_scale').html(w_display+ ' LB | ' + (w * 0.453592).toFixed(1) +' KG');
        },
        slide: function( event, ui ) {
            var w=parseInt(ui.value);
           settings.update_droppers(w);
        }
    }, settings);

    return this.each(function(){
      settings.max = settings.max + 1
        var productSingleObject = productSingleObject || JSON.parse(document.getElementById("ProductJson-product-template").innerHTML);
        var prod_img=productSingleObject.preview_image || productSingleObject.media[0].preview_image
        if(!!productSingleObject.variants)
          settings.options = productSingleObject.variants.map(item => item.title.replace('.',''));
        
        var content='<div class="dosage_wraper"><div class="dosage_input">';
        content+='</div><div class="clear"></div>';
        content+='<div class="dos_right_wrapper '+ settings.pet +'"><div class="arrow_box">Find your pet\'s weight:</div>';
        content+='<div id="dropper_pet"><div id="dropper_pet_content">&nbsp;</div></div>';
        content+= '<div id="dosage_calculator"></div><div class="dosage_result"><div class="weight_in_scale">2 LB|1.0 KG</div>';
         content+='<div id="drops_amount">Your pet will require: <span class="ml">1</span> <strong>' + (settings.times_per_day==2 ? '2x' : '1x') + ' daily</strong></div>';
        content+= '<div class="row">'
        settings.options.forEach(option => {
            var temp_name= option.replace('Default Title','');
            var temp_id= option.replace(' ','').replace('DefaultTitle','');
          if(productSingleObject.variants.length>1 && productSingleObject.variants.find(item => item.title.replace('.','') === option).featured_media) 
          var img=productSingleObject.variants.find(item => item.title.replace('.','') === option).featured_media.preview_image
          else 
              img= prod_img;
            
            content+='<div class="bottles_last col-xs-6 col-md-6" '+ ('SoftChews' == temp_id ? 'style="display:none" ': '') + 'id="droppers_amount_'+ temp_id +'"><img src="' + (img || prod_img).src + '"/><div class="amount_text"><strong>A '+ temp_name +'</strong> bottle will</br>last <span class="days_last">590 days</span>.</div></div>';
        });  
        content+= '</div></div></div>' ;

        content+='';
        content+='<div class="clear"></div></div>';

        jQuery(this).html(content);

        //use current settings plus the input value, refresh this plugin

        //handle the return key calc
        //initialize the
        /*if(settings.bottle_size=="4 oz" )
        {
          settings.drops_per_bottle=2360;
          settings.ml_per_bottle=118;
        }
        else
        {
          settings.drops_per_bottle=1180;
          settings.ml_per_bottle=59;
        }*/
        $( "#dosage_calculator" ).slider(settings);
        var w=parseInt($( "#dosage_calculator" ).slider( "value" ));
        settings.update_droppers(w);
    });

};

var add_cat_dosage_calculator={
        max: 20,
        pet: 'cat',
        value: 10,
        times_per_day: 1,
        scales: ['30','20','10','0lbs']
}

var add_cat_dosage_calculator_twice_a_day={
        max: 20,
        pet: 'cat',
        value: 10,
        scales: ['30','20','10','0lbs']
}

var add_dog_dosage_calculator={
        max: 100,
        value: 40,
        times_per_day: 1,
        scales: ['100','75','50','25','0lbs']
}


var add_dog_dosage_calculator_twice_a_day={
        max: 100,
        value: 40,
        bottle_size:'2 oz',
        scales: ['100','75','50','25','0lbs']
    }

var add_dog_dosage_calculator_twice_a_day_2={
        max: 100,
        value: 40,
        bottle_size:'2 oz',
        drops_per_day:2,
        scales: ['100','75','50','25','0lbs']
    }

var add_cat_dosage_calculator_twice_a_day_2={
      max: 20,
      pet: 'cat',
      value: 10,
      bottle_size:'2 oz',
      drops_per_day:2,
      scales: ['30','20','10','0lbs']
  }

function switch_dosage_bottle_size(new_size)
{
  var dosage_settings =  dosage_settings || eval($( ".dosage_calculator_placeholder" ).attr('rel').replace('(','_').replace(')',''));
  if ($('.dosage_calculator_placeholder').html().length>0)
    dosage_settings.value= $('.dosage_calculator_placeholder #dosage_calculator').slider( "value" );
  dosage_settings.bottle_size = new_size;
  $( ".dosage_calculator_placeholder" ).dosage(dosage_settings);
}

//detect the calculator placeholder



